"use client";

import "@/styles/carousel-base.css";
import { Widget } from "@pulsex/types";
import { cn } from "@pulsex/utils";
import Link from "next/link";
import ImageUI from "../CustomImage/ImageUI";

// export const runtime = "edge"; // 'nodejs' (default) | 'edge'

export default function TabulatedSideNews({ widget }: { widget: Widget }) {
  if (!widget) return null;
  const { posts } = widget;

  if (widget.code === "most-read") {
    return (
      <div className="p-2 py-4 pb-8 max-h-full overflow-y-auto">
        {posts?.map((post, index) => (
          <Link
            href={post.url}
            className="grid grid-cols-12 gap-3 rounded bg-white dark:bg-gray-700/100 p-2 mb-3"
            key={index}
          >
            <ImageUI data={post} className="col-span-4" />
            <div
              className={cn(
                "col-span-8 font-bold text-[13px] opacity-100",
                !post.displayDate && "col-span-12"
              )}
            >
              {post.title}
            </div>
          </Link>
        ))}
      </div>
    );
  }

  return (
    <div className="p-2 py-4 pb-8 max-h-full overflow-y-auto">
      {posts?.map((post, index) => (
        <div
          className="grid grid-cols-12 gap-3 rounded bg-white dark:bg-gray-700/100 p-2 mb-3"
          key={index}
        >
          <div className="col-span-2 text-sm font-bold opacity-30 whitespace-nowrap">
            {post.displayDate}
          </div>
          <div
            className={cn(
              "col-span-10 font-bold text-[13px] opacity-100",
              !post.displayDate && "col-span-12"
            )}
          >
            {post.title}
          </div>
        </div>
      ))}
    </div>
  );
}
